import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font16 } from 'components/Typography'

export const DropzoneModalContainer = styled.div`
  text-align: center;
  margin: 20px 0;
`

export const DropzoneModalTitle = styled.div`
  text-transform: capitalize;
  margin: 36px 0;
`

export const DropzoneModalIcon = styled(Icon)`
  width: 32px;
  height: 32px;
  color: ${theme.colors.dolphinGrey};
`

export const DropzoneModalIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  background: rgba(255, 95, 0, 0.08);
  border-radius: 8px;
  margin-bottom: 32px;
`

export const DropzoneModalDesc = styled.div<{ isDragReject: boolean }>`
  ${Font16};
  padding: 8px;
  color: ${(p) =>
    p.isDragReject ? theme.colors.error : theme.colors.otterWarmBlack};
  white-space: break-spaces;
  word-break: break-word;
`
export const DropzoneModalBody = styled.div<{
  isDragActive: boolean
  isDragReject: boolean
}>`
  margin: 48px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 240px;
  background: ${(p) =>
    p.isDragActive ? theme.colors.dropZoneDark : theme.colors.dropZone};
  border: 1px dashed
    ${(p) => (p.isDragReject ? theme.colors.error : theme.colors.horizonOrange)};
  border-radius: 8px;
  cursor: pointer;
`

export const DropzoneButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
